import axios from "axios";

/**
 * Resolve backend URL with safe fallbacks:
 * 1. Use REACT_APP_BACKEND_URL if set AND reachable on the same origin family
 * 2. Otherwise fall back to window.location.origin (works on Emergent — frontend & backend share origin via /api/* routing)
 * 3. SSR fallback to env var (Node has no window)
 */
function resolveBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === "undefined") {
    return envUrl || "";
  }
  // In browser: prefer current origin (works for preview, production, custom domains).
  // This makes the app resilient to misconfigured REACT_APP_BACKEND_URL in build env.
  if (envUrl && envUrl.startsWith("http")) {
    try {
      const envOrigin = new URL(envUrl).origin;
      // If env URL matches current origin, use it (developer's explicit choice).
      if (envOrigin === window.location.origin) return envUrl;
    } catch {
      // Malformed env URL — fall through to origin.
    }
  }
  return window.location.origin;
}

const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function apiError(err, fallback = "Something went wrong") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || "Invalid input").join(", ");
  return fallback;
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("crash_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
